/* eslint-disable react/prefer-stateless-function */
import { Component } from 'react';
import Select from 'react-select';
import classnames from 'classnames';
import styles from './dropdown.scss';

/* eslint-disable react/prop-types */ // TODO: add props

class Dropdown extends Component {
  render() {
    const { className, children, size, controlId, dataTest, ...props } =
      this.props;
    const classes = classnames(className, styles.dropdown, styles[size], {});
    const inputProps = {};
    if (controlId) {
      inputProps.id = controlId;
    }
    if (dataTest) {
      inputProps['data-test'] = dataTest;
    }

    return (
      <Select inputProps={inputProps} {...props} className={classes}>
        {children}
      </Select>
    );
  }
}

export default Dropdown;
